(function () {
  function init() {
    var sticky = document.querySelector('[data-sticky-atc]');
    var atcSection = document.querySelector('.rvt-product');
    if (!sticky || !atcSection) return;

    var mainAtc = atcSection.querySelector('[data-atc-btn]');
    var submitBtn = sticky.querySelector('[data-sticky-submit]');
    var formId = sticky.dataset.triggerForm;

    // Show sticky after scrolling past the main ATC button
    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (!entry.isIntersecting) {
        sticky.setAttribute('data-visible', '');
        sticky.removeAttribute('aria-hidden');
      } else {
        sticky.removeAttribute('data-visible');
        sticky.setAttribute('aria-hidden', 'true');
      }
    }, { threshold: 0.1 });

    if (mainAtc) io.observe(mainAtc);

    // Sticky submit → click real form submit button
    if (submitBtn && formId) {
      submitBtn.addEventListener('click', function () {
        var realBtn = document.querySelector('#' + formId + ' [data-atc-btn], [form="' + formId + '"][data-atc-btn]');
        if (realBtn && !realBtn.disabled) {
          realBtn.click();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
